import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { themeGet } from '@styled-system/theme-get';

import { isWindows } from '~/renderer/utils';

export const SIDEBAR_WIDTH = '30%';
export const ANIMATION_DURATION = themeGet('transition.transition-duration-slow');
export const MOVE_ONTO_SCREEN_FUNC = 'cubic-bezier(0, 0, 0.2, 1)';
export const MOVE_OFF_SCREEN_FUNC = 'cubic-bezier(0.4, 0, 1, 1)';

interface StyledSidebarProps {
  isClosed?: boolean;
}
interface SidebarItemProps {
  isActive?: boolean;
  isDefaultCursor?: boolean;
}

export const StyledSidebar = styled(Flex)<StyledSidebarProps>`
  box-shadow: ${props =>
    isWindows ? `inset 0px 1px 0px ${themeGet('colors.gray-100')(props)}` : 'none'};
  width: ${SIDEBAR_WIDTH};
  position: fixed;
  height: 100vh;
  z-index: 10;
  transition: all;
  transition-duration: ${ANIMATION_DURATION};
  border-right: solid 1px ${themeGet('colors.gray-100')};
  ${props =>
    props.isClosed
      ? `
          transition-timing-function: ${MOVE_ONTO_SCREEN_FUNC};
          transform: translateX(-100%);
        `
      : `
          transition-timing-function: ${MOVE_OFF_SCREEN_FUNC};
          transform: translateX();
    `}
  background-color: white;
  flex-direction: column;
  justify-content: space-between;
  cursor: default;
`;

export const StyledSidebarItem = styled(Box)<SidebarItemProps>`
  padding: ${themeGet('space.2')} ${themeGet('space.3')};
  pointer-events: ${props => (props.isActive ? 'none' : 'auto')};
  background-color: ${props => (props.isActive ? themeGet('colors.gray-50') : '')};
  cursor: ${props => (props.isDefaultCursor ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  ${props =>
    props.isActive
      ? `box-shadow: inset calc(${themeGet('space.1')(props)} / 2) 0 0 0 ${themeGet(
          'colors.blue-500',
        )(props)}`
      : ''};
`;

export const StyledLinkButton = styled(Button)`
  padding: 0;
  min-height: auto;
  background: none;
  outline: none;
  border: none;
  box-shadow: none;

  &:focus,
  &:hover,
  &:active {
    background: none;
    outline: none;
    border: none;
    box-shadow: none;
  }
`;

export const StyledBox = styled(Flex)`
  margin-left: ${themeGet('space.2')};
  color: ${themeGet('colors.gray-850')};
  font-weight: ${themeGet('fontWeights.bold')};
  width: 100%;
  justify-content: center;
  flex-direction: column;
`;

export const StyledConnectionBox = styled(StyledBox)`
  font-size: ${themeGet('fontSizes.text-s')};
  color: ${themeGet('colors.gray-600')};
  font-weight: ${themeGet('fontWeights.regular')};
  margin-left: ${themeGet('space.2')};
`;

export const StyledText = styled(Text)`
  font-size: ${themeGet('fontSizes.text')};
  line-height: ${themeGet('lineHeights.4')};
  color: ${themeGet('colors.gray-600')};
  letter-spacing: 0;
`;
